import { useSortable } from '@dnd-kit/sortable';
import { useContext } from 'react';

import { DragIcon } from '@/icons/index';

import CourseEditContext from '../CourseEditContext';

import { StyledDragItem } from './CourseOutcomeTab.Styles';
import OutcomeEditor from './OutcomeEditor';

interface DraggableOutcomeProps {
	isDragDisabled: boolean;
	index: number;
	outcome: CoursesOutcomesEntity;
}

const DraggableOutcome = ({ index, outcome, isDragDisabled }: DraggableOutcomeProps) => {
	const { canEdit, removeOutcome } = useContext(CourseEditContext);
	const removeSetOutcome = (key: string) => removeOutcome(key);
	const { outcome_id: outcomeId, outcome_text: outcomeText } = outcome.outcome;

	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
		id: outcome.courses_outcomes_id,
		disabled: isDragDisabled,
	});

	const style = {
		transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
		transition,
	};

	return (
		<StyledDragItem ref={setNodeRef} style={style} data-testid={`outcome-${index}`}>
			{canEdit && !isDragDisabled && (
				<div className="drag-icon-wrapper" {...attributes} {...listeners}>
					<DragIcon />
				</div>
			)}
			<OutcomeEditor
				key={outcome.courses_outcomes_id}
				text={outcomeText}
				id={outcomeId}
				onRemoveEvent={() => removeSetOutcome(outcome.courses_outcomes_id)}
			/>
		</StyledDragItem>
	);
};
export default DraggableOutcome;
